import React, { ComponentProps } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import { MobAppDownload } from '../../lib';

function RouteMobAppDownload(props: RouteComponentProps & ComponentProps<any>) {
  const parentPath: string = fomatParentPath(props);
  return (
    <Route weId={`${props.weId || ''}_pb8iga`} exact path={`${parentPath}/mobile/uk/appDownload`}>
      {
        <MobAppDownload weId={`${props.weId || ''}_kj0za7`} />
      }
    </Route>
  )
}

export default withRouter(RouteMobAppDownload);